import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import "react-quill/dist/quill.snow.css"
import { useNavigate } from "react-router-dom"
import { Select, Typography, Button } from "antd"
import { Container, Row, Col } from "reactstrap"
import ReactQuill from "react-quill"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { getPrivacy, updatePrivacy } from "store/resources/action"
import { useDispatch, useSelector } from "react-redux"
const { Title, Text } = Typography
//i18n
import { withTranslation } from "react-i18next"
const { Option } = Select
const PrivacyPolicy = props => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, privacyData } = useSelector(state => state.ResourcesReducer)
  const { currentUser } = useSelector(state => state.Login)
  const [value, setValue] = useState("")

  const handleChange = content => {
    setValue(content)
  }

  useEffect(() => {
    dispatch(getPrivacy({ id: currentUser.organization_id }))
  }, [])
  useEffect(() => {
    if (privacyData?.details) {
      setValue(privacyData.details)
    }
  }, [privacyData?.details])

  const handleSaveChanges = () => {
    const payload = {
      id: currentUser.id,
      data: { details: value },
    }
    dispatch(updatePrivacy(payload))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Dashboard" breadcrumbItem="Privacy Policy" />
          <Row>
            <Col>
              <Title level={3}>Privacy Policy</Title>
            </Col>
          </Row>
          <Row>
            <Col>
              <ReactQuill
                value={value}
                onChange={handleChange}
                // theme="snow"
                modules={{ toolbar: true }}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Button
                className="bg-primary w-xl text-white"
                style={{
                  float: "right",
                }}
                onClick={handleSaveChanges}
                disabled={loading}
              >
                Save Changes
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

PrivacyPolicy.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(PrivacyPolicy)
